import * as Types from '../actions/Types'
import DB from '../database/offlineDB.json'

const INITIAL_STATE = {
  user: null,
  apartment: null,
  community: null,
  privileges: null,
  // Fetched is that the meta data above i fetched.
  fetched: false,
  laundries: [],
  laundryTimes: [],
  laundryRules: null,
  laundrySystemFetched: false,
  communityInformationItems: [],
  communityInformationFetched: false,
  posts: [],
  postsFetched: false,
  bookingSystems: [],
  bookingSystemsFetched: false
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action
  switch (type) {
  case Types.GET_SELF_SUCCESS:
    return {
      ...state,
      ...parseSelf(payload)
    }
  case Types.INIT_OFFLINE_MODE:
    return {
      ...state,
      ...parseSelf(DB.meta.data),
      laundries: DB.laundrySystems.data.laundries,
      laundryTimes: DB.laundrySystems.data.times,
      laundryRules: DB.laundrySystems.data.laundryRule,
      laundrySystemFetched: true,
      bookingSystems: parseBookingSystems(DB.bookingSystems.data),
      bookingSystemsFetched: true,
      communityInformationItems: DB.communityInformations.data,
      communityInformationFetched: true,
      posts: parsePosts(DB.feed.data),
      postsFetched: true
    }
  case Types.UPDATE_USER_SUCCESS:
    return {
      ...state,
      user: payload
    }
  case Types.GET_LAUNDRY_SYSTEM_SUCCESS:
    return {
      ...state,
      laundries: payload.laundries,
      laundryTimes: payload.times,
      laundryRules: payload.laundryRule,
      laundrySystemFetched: true
    }
  case Types.GET_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: parseBookingSystems(payload),
      bookingSystemsFetched: true
    }
  case Types.GET_COMMUNITY_INFORMATIONS_SUCCESS:
    return {
      ...state,
      communityInformationItems: payload,
      communityInformationFetched: true
    }
  case Types.GET_POSTS_SUCCESS:
    return {
      ...state,
      posts: parsePosts(payload),
      postsFetched: true
    }
  case Types.MAKE_BOOKING_SUCCESS:
    return {
      ...state,
      laundryTimes: addLaundryBooking(payload, state, state.apartment)
    }
  case Types.MAKE_BOOKING_FAILED:
    if (payload.status === 409) {
      return {
        ...state,
        laundryTimes: addLaundryBooking(payload.data.data, state, {
          id: payload.data.data.apartmentId,
          number: ''
        })
      }
    }

    return {
      ...state
    }
  case Types.DELETE_BOOKING_SUCCESS:
    return {
      ...state,
      laundryTimes: deleteLaundryBooking(payload, state)
    }
  case Types.SUBSCIRBE_TO_BOOKING_SUCCESS:
    return {
      ...state,
      laundryTimes: addSubscriptionToBooking(state.laundryTimes, payload)
    }
  case Types.UNSUBSCIRBE_TO_BOOKING_SUCCESS:
    return {
      ...state,
      laundryTimes: removeSubscriptionFromBooking(state.laundryTimes, payload)
    }
  case Types.LIKE_POST_SUCCESSFUL:
    return {
      ...state,
      posts: addLikeToPost(payload, state)
    }
  case Types.DISLIKE_POST_SUCCESSFUL:
    return {
      ...state,
      posts: removeLikeFromPost(payload, state)
    }
  case Types.COMMENT_POST_SUCCESSFUL:
    return {
      ...state,
      posts: addCommentToPost(payload, state)
    }
  case Types.DELETE_COMMENT_SUCCESSFUL:
    return {
      ...state,
      posts: deleteCommentFromPost(payload, state)
    }
  case Types.CREATE_NEW_POST_SUCCESSFUL:
    return {
      ...state,
      posts: [payload, ...state.posts]
    }
  case Types.DELETE_POST_SUCCESSFUL:
    return {
      ...state,
      posts: deletePost(payload, state)
    }
  case Types.CREATE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: addBookingForBookingSystem(payload, state)
    }
  case Types.DELETE_BOOKING_FOR_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: deleteBookingForBookingSystem(payload, state)
    }
  default:
    return state
  }
}

function parseSelf(data) {
  return {
    user: {
      id: data.id,
      type: data.type,
      email: data.email,
      phone: data.phone
    },
    apartment: {
      id: data.apartment.id,
      number: data.apartment.number
    },
    community: {
      id: data.apartment.community.id,
      name: data.apartment.community.name,
      laundrySetupDone: data.apartment.community.laundrySetupDone
    },
    privileges: data.apartment.community.privileges,
    fetched: true
  }
}

function addLaundryBooking(payload, state, apartment) {
  const times = state.laundryTimes.map(time => {
    if (time.id.toString() === payload.timeId.toString()) {
      time.bookings.push({ ...payload, apartment, bookingSubscriptions: [] })
    }

    return time
  })

  return times
}

function parseBookingSystems(systems) {
  const parsed = {}

  systems.forEach(system => {
    parsed[system.bookableObject.id] = {
      ...system.bookableObject
    }
  })

  return parsed
}

function addBookingForBookingSystem(payload, state) {
  const systems = state.bookingSystems

  systems[payload.systemId].times = systems[payload.systemId].times.map(t => {
    if (t.id === payload.data.bookableTimeId) {
      t.bookings.push(payload.data)
    }

    return t
  })

  return systems
}

function deleteBookingForBookingSystem(payload, state) {
  const systems = state.bookingSystems

  systems[payload.systemId].times = systems[payload.systemId].times.map(t => {
    t.bookings = t.bookings.filter(b => b.id !== payload.bookingId)

    return t
  })

  return systems
}

function parsePosts(posts) {
  const parsed = {}

  posts.forEach(post => {
    parsed[post.id] = { ...post }
  })

  return parsed
}

function addLikeToPost(payload, state) {
  const posts = { ...state.posts }

  posts[payload.postId].likes = [...posts[payload.postId].likes, payload]

  return posts
}

function removeLikeFromPost(payload, state) {
  const posts = { ...state.posts }

  posts[payload.postId].likes = posts[payload.postId].likes.filter(
    l => l.apartmentId !== payload.apartmentId
  )

  return posts
}

function addCommentToPost(payload, state) {
  const posts = { ...state.posts }

  posts[payload.postId].comments = [
    ...posts[payload.postId].comments,
    { ...payload, apartment: state.apartment }
  ]

  return posts
}

function deleteCommentFromPost(payload, state) {
  const posts = { ...state.posts }

  posts[payload.postId].comments = posts[payload.postId].comments.filter(
    c => c.id !== payload.commentId
  )

  return posts
}

function deletePost(payload, state) {
  const posts = state.posts

  delete posts[payload]

  return posts
}

function addSubscriptionToBooking(laundryTimes, payload) {
  const times = laundryTimes.map(time => {
    time.bookings = time.bookings.map(booking => {
      if (booking.id.toString() === payload.bookingId.toString()) {
        booking.bookingSubscriptions.push(payload)
      }

      return booking
    })

    return time
  })

  return [...times]
}

function removeSubscriptionFromBooking(laundryTimes, payload) {
  const times = laundryTimes.map(time => {
    time.bookings = time.bookings.map(booking => {
      if (booking.id.toString() === payload.toString()) {
        booking.bookingSubscriptions = []
      }

      return booking
    })

    return time
  })

  return [...times]
}

function deleteLaundryBooking(payload, state) {
  const times = state.laundryTimes.map(time => {
    time.bookings = time.bookings.filter(
      booking => booking.id.toString() !== payload.toString()
    )

    return time
  })

  return times
}



// WEBPACK FOOTER //
// ./src/reducers/Data.js